<template>
  <div id="app">
    <vue-headful :title="$t('appTitle')" />
    <Header />
    <Navigation />
    <div class="content">
      <router-view />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Navigation from "@/components/Navigation.vue";
import Footer from "@/components/Footer.vue";
import vueHeadful from "vue-headful";

export default {
  name: "App",
  data() {
    return {
      steps: ["Energies", "Consommations"]
    };
  },
  created() {
    if (!this.$store.state.contact.civilities.length) {
      this.$store.dispatch("contact/getCivilities", this.$i18n.locale);
    }
  },
  components: {
    Header,
    Navigation,
    Footer,
    vueHeadful
  }
};
</script>

<style lang="scss">
@font-face {
  font-family: ObjectSans;
  src: url("./assets/fonts/ObjectSans-Regular.otf");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: ObjectSans;
  src: url("./assets/fonts/ObjectSans-Medium.otf");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: ObjectSans;
  src: url("./assets/fonts/ObjectSans-Bold.otf");
  font-weight: 600;
  font-style: normal;
}

html,
body {
  height: 100%;
  margin: 0;

  &.modal-open {
    max-height: calc(100vh - 210px);
    overflow-y: hidden;
  }
}

#app {
  font-family: "ObjectSans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #231f20;
  display: flex;
  flex-direction: column;

  .content {
    background: white;
    flex: 1 0 auto;
  }

  .footer {
    flex-shrink: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue